/* tslint:disable */

declare var Object: any;
export interface ProductImageInterface {
  "productType": string;
  "planType": string;
  "name": string;
  "description": string;
  "id"?: number;
}

export class ProductImage implements ProductImageInterface {
  "productType": string;
  "planType": string;
  "name": string;
  "description": string;
  "id": number;
  constructor(data?: ProductImageInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ProductImage`.
   */
  public static getModelName() {
    return "ProductImage";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ProductImage for dynamic purposes.
  **/
  public static factory(data: ProductImageInterface): ProductImage{
    return new ProductImage(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ProductImage',
      plural: 'ProductImages',
      path: 'ProductImages',
      idName: 'id',
      properties: {
        "productType": {
          name: 'productType',
          type: 'string'
        },
        "planType": {
          name: 'planType',
          type: 'string'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
